export const H = {
    header: document.querySelector('.js-header'), 

    init: () => {
        if (H.header) {
            let resizeTimeout = null;
            const header = H.header;
            const bodyScreen = document.querySelector('body');
            const homeBanner = document.querySelector('.homepage');
            const hasHB = !!homeBanner;
            const offsetTop = hasHB ? 600 : 338;

            const handleScroll = () => {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;

                if (scrollTop >= 70) header.classList.add('logo-sm');
                else header.classList.remove('logo-sm');

                if (scrollTop >= 160) header.classList.add('logo-xs');
                else header.classList.remove('logo-xs');

                if (scrollTop >= 240) header.classList.add('logo-bg');
                else header.classList.remove('logo-bg');

                if (hasHB) {
                    if (scrollTop >= 70) homeBanner.classList.add('hide-el');
                    else homeBanner.classList.remove('hide-el');
                }

                header.classList.add('logo-transition');
                if (scrollTop >= offsetTop) {
                    header.classList.add('affix');
                    if (bodyScreen) bodyScreen.classList.add('affix-nav');
                } else {
                    header.classList.remove('affix');
                    if (bodyScreen) bodyScreen.classList.remove('affix-nav');
                }
            };

            const handleResize = () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    header.classList.remove('affix', 'affix-top', 'affix-bottom');
                    handleScroll();
                }, 100);
            };

            if (window.scrollY === 0) {
                setTimeout(() => header.classList.add('started'), 620);
            } else {
                header.classList.add('started');
            }

            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleResize);

            handleScroll();
        }

        const dropdownLinks = document.querySelectorAll(".navbar .nav-item.dropdown > a");
        dropdownLinks.forEach(link => {
            link.addEventListener("click", function (e) {
                if (window.innerWidth < 992) {
                    e.preventDefault();

                    const parent = this.parentElement;
                    const menu = parent.querySelector(".dropdown-menu");

                    if (menu) {
                        const isOpen = menu.classList.contains("show");

                        document.querySelectorAll(".navbar .dropdown-menu.show").forEach(m => {
                            m.classList.remove("show");
                        });

                        if (!isOpen) {
                            menu.classList.add("show");
                        }
                    }
                }
            });
        });
    }
}